import axios from '@/libs/api.request'

export const getPlayList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/play/page'
  })
}
// 获取小程序列表
export const getMinisPlayList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/play/minisList'
  })
}
// 编辑短剧
export const editPlay = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/play/update'
  })
}
// 查询短剧绑定小程序及定时发布详情
export const getPlayPublishDetail = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/play/publish/detail'
  })
}
// 批量发布短剧至外部查询
export const batchUpdateExternalRelease = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/play/batch/external/update'
  })
}
// 短剧从发布改成未发布检查状态
export const getSeriesByPlayId = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/config/getSeriesByPlayId'
  })
}
